import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Chat from 'vue-beautiful-chat'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import VueTour from 'vue-tour';
import vmodal from 'vue-js-modal';
import VueMeta from 'vue-meta'
import JsonSchemaEditor from 'json-schema-editor-vue'
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";
// import Profiler from "./utils/profiler"

require('vue-tour/dist/vue-tour.css')

Amplify.configure(awsconfig);
//Vue.mixin(Profiler)
Vue.use(Chat)
Vue.use(Vuex)
Vue.use(VueTour)
Vue.use(vmodal)
Vue.use(VueMeta)
Vue.use(JsonSchemaEditor)

// Sentry.init({
// 	Vue,
// 	dsn: "https://02ba0865bd0e4c2a82be8ad1c1e955cf@o1182848.ingest.sentry.io/6301142",
// 	integrations: [
// 	  new BrowserTracing({
// 		routingInstrumentation: Sentry.vueRouterInstrumentation(router),
// 		tracingOrigins: ["app.inmatic.ai", /^\//],
// 	  }),
// 	],
// 	// Set tracesSampleRate to 1.0 to capture 100%
// 	// of transactions for performance monitoring.
// 	// We recommend adjusting this value in production
// 	tracesSampleRate: 0.01,
// });

Vue.config.productionTip = false
export const bus = new Vue();
new Vue({
	store,
	vuetify,
	router,
	render: h => h(App)
}).$mount('#app')
